import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import CategoryService from "../../../../service/CategoryService";
import { Button } from "primereact/button";
import NewCategories from "../NewCategories/NewCategories";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { FilterMatchMode } from "primereact/api";

const ListCategoriesRegistered = () => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategory] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [descriptionEnglish, setDescriptionEnglish] = useState("");
  const [descriptionItalian, setDescriptionItalian] = useState("");
  const [descriptionPortuguese, setDescriptionPortuguese] = useState("");
  const [descriptionSpanish, setDescriptionSpanish] = useState("");
  const [id, setId] = useState("");
  const [imageid, setImageid] = useState("");

  const categoryService = new CategoryService();
  const toast = useRef(null);
  const newCategoryRef = useRef(null);

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        setLoading(true);

        const res = await categoryService.getCategories(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );

        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoading(false);
        } else {
          setCategory(res.result);
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filters2 = {
    "category.descriptionEnglish": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "category.descriptionItalian": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "category.descriptionSpanish": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "category.descriptionPortuguese": { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("categoriesRegistered")}</h3>

      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={categories}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          header={localeText("image")}
          body={(category) => {
            return (
              <Link to={`/category?id=${category.id}`}>
                <AdvancedImage
                  cldImg={cloudinaryInstance
                    .image(category.imageid)
                    .format("webp")
                    .resize(fill().width(600).height(600))}
                  height={75}
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round product-thumbnail"
                />
              </Link>
            );
          }}
          style={{ width: "20%" }}
        />
        <Column
          field="descriptionEnglish"
          header={localeText("descriptionEN")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(category) => {
            return <span>{category.descriptionEnglish}</span>;
          }}
        />
        <Column
          field="descriptionItalian"
          header={localeText("descriptionIT")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(category) => {
            return <span>{category.descriptionItalian}</span>;
          }}
        />
        <Column
          field="descriptionPortuguese"
          header={localeText("descriptionPT")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(category) => {
            return <span>{category.descriptionPortuguese}</span>;
          }}
        />
        <Column
          field="descriptionSpanish"
          header={localeText("descriptionES")}
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "20%" }}
          body={(category) => {
            return <span>{category.descriptionSpanish}</span>;
          }}
        />
        <Column
          field="descriptionES"
          header={localeText("edit")}
          style={{ width: "20%" }}
          body={(category) => {
            return (
              <Button
                icon="pi pi-pencil"
                onClick={() => {
                  setIsEdit(false);
                  setDescriptionEnglish(category.descriptionEnglish);
                  setDescriptionItalian(category.descriptionItalian);
                  setDescriptionPortuguese(category.descriptionPortuguese);
                  setDescriptionSpanish(category.descriptionSpanish);
                  setId(category.id);
                  setImageid(category.imageid);
                  setIsEdit(true);

                  setTimeout(
                    () => newCategoryRef.current.scrollIntoView({ behavior: "smooth" }),
                    100
                  );
                }}
                style={{ textSize: "4em" }}
              />
            );
          }}
        />
      </DataTable>
      <div ref={newCategoryRef} id="NewCategories">
        {isEdit && (
          <NewCategories
            descriptionEN={descriptionEnglish}
            descriptionES={descriptionSpanish}
            descriptionIT={descriptionItalian}
            descriptionPT={descriptionPortuguese}
            id={id}
            images={imageid}
            isEdit={isEdit}
          />
        )}
      </div>
    </div>
  );
};

export default ListCategoriesRegistered;
